import { entityKeys } from '../../lib/entity-queries'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { assistantEffects } from '@/lib/assistant-effects.generated'
import { policyOrderApi, policyOrderKeys, policyResultKeys, type PolicyPlacement } from '../../api/policy-order-api'
import { policyCatalogApi, policyCatalogKeys } from '../../api/policy-catalog-api'

export function useSetPolicyEnabled(entityId: string, valueType: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ policyId, expectedRevision, enabled }: { policyId: string; expectedRevision: number; enabled: boolean }) =>
      policyCatalogApi.setEnabled(entityId, valueType, policyId, expectedRevision, enabled),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: policyResultKeys.all(entityId) }),
        queryClient.invalidateQueries({ queryKey: entityKeys.settings(entityId) }),
        queryClient.invalidateQueries({ queryKey: ['assistant-availability'] }),
        queryClient.invalidateQueries({ queryKey: entityKeys.brandingRoot }),
        queryClient.invalidateQueries({ queryKey: policyOrderKeys.all(entityId) }),
        queryClient.invalidateQueries({ queryKey: policyCatalogKeys.all(entityId) }),
      ])
    },
  })
}

export function usePolicyOrder(entityId: string, valueType: string, enabled = true) {
  return useQuery({ queryKey: policyOrderKeys.type(entityId, valueType), queryFn: () => policyOrderApi.read(entityId, valueType), enabled, meta: { assistantEffects: [assistantEffects.settingsChanged] } })
}

export function useMovePolicy(entityId: string, valueType: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ policyId, placement }: { policyId: string; placement: PolicyPlacement }) => policyOrderApi.move(entityId, valueType, policyId, placement),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: policyResultKeys.all(entityId) }),
        queryClient.invalidateQueries({ queryKey: entityKeys.brandingRoot }),
        queryClient.invalidateQueries({ queryKey: policyOrderKeys.all(entityId) }),
        queryClient.invalidateQueries({ queryKey: policyCatalogKeys.all(entityId) }),
      ])
    },
  })
}
